// @flow

import React, { Component } from "react"
import { Redirect } from "react-router-dom"
import { connect } from "react-redux"
import { login, recoverPassword } from "../../actions"
import ReduxToastr, { toastr } from "react-redux-toastr"

import Input from "react-toolbox/lib/input/Input"
import Button from "react-toolbox/lib/button/Button"
import Card from "../../components/Card"

import styles from "./style.css"

class Login extends Component {
  props: {
    auth: any,
    login: ( u: string, p: string ) => any,
    recoverPassword: ( re: string ) => any,
    history: {
      push: () => any,
    },
  }

  state = {
    email: "",
    recoverEmail: "",
    password: "",
    emailError: false,
    showLoginForm: true,
    isActive: false,

  };

  toggleForm = () => {
    this.setState( {
      emailError: false,
      showLoginForm: !this.state.showLoginForm,
    } )
  }

  handleChange = field => value => this.setState( {
    [ field ]: value,
  } )


  submit = event => {
    const { email, password } = this.state
    let emailError = true
    const emailValidation = /^.+@.+$/
    event.preventDefault()
    if ( emailValidation.test( email ) ) {
      this.props.login( email, password )
      emailError = false
    }
    this.setState( {
      emailError,
    } )
  }

  recoverySubmit = event => {
    const { recoverEmail } = this.state
    const emailValidation = /^.+@.+$/

    let emailError = true
    let success = false

    event.preventDefault()
    if ( emailValidation.test( recoverEmail ) ) {
      recoverPassword( recoverEmail ).then(
        ( ( result ) => {
          if ( result.message === "OK" ) {
            toastr.success( "Email Enviado" )
            this.toggleForm()
          } else {
            toastr.error( "Email nao encontrado" )
          }

        } ).bind( this )
      )

      emailError = false

    }
    this.setState( {
      emailError,
      showLoginForm: success,
    } )
  }

  renderComponent = ( showLoginForm ) => {
    if ( showLoginForm ) {

      const { auth } = this.props

      return (
        <div>
          <div className={styles.recoveryEmail}>
            <Input
              type="email"
              label="Email"
              icon="email"
              value={this.state.email}
              onChange={this.handleChange( "email" )}
              error={this.state.emailError ? "Email inválido" : false}
            />
          </div>
          <Input
            type="password"
            label="Password"
            icon="lock_outline"
            value={this.state.password}
            onChange={this.handleChange( "password" )}
          />
          <div className={styles.bottomRow}>
            <div className={styles.column}>
              <div className={styles.statusMessage}>
                {auth.message !== "" ? "Error login" : ""}
              </div>
              <div onClick={this.toggleForm.bind( this )} className={styles.forgotPassword}>
                <span className={styles.forgotPassword}>
                        Esqueceu a palavra-passe?
                </span>
              </div>
            </div>
            <Button
              raised
              primary
              label="Login"
              type="submit"
              onClick={this.submit}
            />
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <div className={styles.title}>
                  Recuperar Conta
          </div>
          <Input
            type="email"
            label="Email"
            icon="email"
            value={this.state.recoverEmail}
            onChange={this.handleChange( "recoverEmail" )}
            error={this.state.emailError ? "Email inválido" : false}
          />
          <div className={styles.recoverButton}>
            <div
              className="material-icons"
              onClick={this.toggleForm.bind( this )}
              role="button"
              tabIndex="0">
                    arrow_back
            </div>

            <Button
              raised
              primary
              label="Recuperar Password"
              onClick={this.recoverySubmit}
            />
          </div>
        </div>
      )
    }
  }

  render () {
    const { auth } = this.props
    const { showLoginForm } = this.state

    if ( auth.ok === true ) {
      return <Redirect to="/" />
    } else {
      const backgroundUrl = process.env.PUBLIC_URL + "/assets/img/login_background.png"

      return (
        <div
          style={{
            background: "url(" + backgroundUrl + ") no-repeat center center fixed",
            backgroundSize: "cover",
          }}
          className={styles.wrapper}
        >
          <Card>
            <form
              autoComplete="off"
              onSubmit={this.submit}
              className={styles.loginBox}
            >
              <div className={styles.logo}>
                <b>Private</b> Lawyers
              </div>

              { this.renderComponent( showLoginForm ) }

            </form>
          </Card>

          <ReduxToastr
            timeOut={4000}
            newestOnTop={false}
            preventDuplicates
            position="top-left"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
            progressBar
          />
        </div>
      )

    }
  }

}

const mapStateToProps = ( state ) => {
  return {
    auth: state.auth,
  }
}

export default connect( mapStateToProps, { login } )( Login )



// WEBPACK FOOTER //
// ./src/views/Login/index.jsx